<template>
  <modal v-bind="$attrs" v-on="$listeners">
    <div slot="header"><h6>{{$t('credit.addCredit')}} {{client.name}}</h6></div>
    <form @submit.prevent="addCredits">
      <div class="row">
        <div class="col-12">
          <fg-input :error="getError($t('client.management.credit.type'))"
                    :label="$t('client.management.credit.type')"
                    required
          >
            <el-select class="select-default"
                       :name="$t('client.management.credit.type')"
                       :placeholder="$t('client.management.credit.type')"
                       :error="getError($t('client.management.credit.type'))"
                       v-validate="modelValidations.product_id"
                       v-model="model.product_id"
                       @change="onProductChange"
                       filterable
                       clearable>
              <el-option class="select-default"
                         v-for="option in creditProducts"
                         :value="option.product_id"
                         :label="option.name"
                         :key="option.product_id">
              </el-option>
              <el-option class="select-default" value="new-product">
                <div class="d-flex align-items-center"><PlusIcon class="mr-1"/>{{$t('client.management.credit.newProduct')}}</div>
              </el-option>
            </el-select>
          </fg-input>
        </div>
        <div class="col-12">
          <fg-input :error="getError($t('client.management.credit.name'))"
                    :label="$t('client.management.credit.name')"
                    :placeholder="$t('client.management.credit.name')"
                    :name="$t('client.management.credit.name')"
                    v-model="model.name"
                    v-validate="modelValidations.required"
                    required
          >
          </fg-input>
        </div>
        <div class="col-12">
          <fg-input :label="$t('generic.user')"
                    :error="getError($t('generic.user'))"
                    required>
            <user-autocomplete v-model="user"
                               v-validate="modelValidations.required"
                               :search-params="{'match[client_uuid]': client.uuid}"
                               :multiple="false"
                               :name="$t('generic.user')"
                               class="w-full"
            />
          </fg-input>
        </div>
        <div class="col-12">
          <fg-input :placeholder="$t('client.management.credit.validTill')"
                    :name="$t('client.management.credit.validTill')"
                    :label="$t('client.management.credit.validTill')"
                    :picker-options="pickerOptions"
                    component="el-date-picker"
                    :value-format="DEFAULT_DATETIME_FULL_FORMAT"
                    v-model="model.valid_till"
          >
          </fg-input>
        </div>
        <div class="col-12">
          <fg-input :placeholder="$t('client.management.credit.amount')"
                    :disabled="selectedProduct.amount"
                    :name="$t('client.management.credit.amount')"
                    :error="getError($t('client.management.credit.amount'))"
                    :label="$t('client.management.credit.amount')"
                    v-validate="modelValidations.amount"
                    type="number"
                    v-model="model.amount">
          </fg-input>
        </div>
        <div class="col-12">
          <fg-input :placeholder="$t('client.management.credit.price')"
                    :disabled="selectedProduct.amount"
                    :name="$t('client.management.credit.price')"
                    :error="getError($t('client.management.credit.price'))"
                    :label="`${$t('client.management.credit.price')} (${currencySymbol})`"
                    v-validate="modelValidations.price"
                    type="number"
                    v-model="model.price">
          </fg-input>
        </div>
        <div class="col-12">
          <fg-input :placeholder="$t('client.management.credit.poNumber')"
                    :label="$t('client.management.credit.poNumber')"
                    :name="$t('client.management.credit.poNumber')"
                    v-model="model.po_number">
          </fg-input>
        </div>
        <div class="flex justify-center w-full">
          <submit-button native-type="submit"/>
        </div>
      </div>

    </form>
  </modal>
</template>
<script>
  import get from 'lodash/get'
  import Vue from 'vue'
  import { mapGetters, mapState } from 'vuex'
  import addYears from 'date-fns/addYears'
  import { PlusIcon } from 'vue-feather-icons'
  import { Select, Option, DatePicker } from 'element-ui'
  import { DEFAULT_DATETIME_FULL_FORMAT } from 'src/config/dateUtils'
  import UserAutocomplete from '@/components/Autocomplete/UserAutocomplete'
  Vue.use(DatePicker)
  Vue.use(Select)
  Vue.use(Option)
  export default {
    inheritAttrs: false,
    components: {
      PlusIcon,
      UserAutocomplete
    },
    props: {
      client: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        DEFAULT_DATETIME_FULL_FORMAT,
        selectedProduct: {},
        pickerOptions: {},
        user: null,
        model: {
          name: '',
          user_uuid: '',
          po_number: '',
          product_id: '',
          client_id: this.client.uuid || this.$route.params.id,
          valid_till: this.$formatDate(addYears(new Date(), 1), DEFAULT_DATETIME_FULL_FORMAT),
          price: 0,
          amount: 0,
        }
      }
    },
    computed: {
      ...mapGetters('config', ['creditProducts']),
      ...mapState({
        currencySymbol: state => state.config.currencySymbol
      }),
      modelValidations () {
        return {
          amount: {
            required: true,
            min_value: 0,
            numeric: true
          },
          price: {
            required: true,
            min_value: 0,
            numeric: true
          },
          product_id: {
            required: true
          },
          po_number: {
            required: true
          },
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onProductChange (productId) {
        if (productId === 'new-product') {
          this.$router.push('/settings/products/create?product_type=credit')
          return
        }
        let product = this.creditProducts.find(p => p.product_id === productId)
        if (product) {
          this.selectedProduct = product
          this.model.name = product.name
          this.model.price = product.price
          this.model.amount = product.amount || 1
        }
      },
      async addCredits() {
        let res = await this.$validator.validateAll()
        if (!res) {
          return
        }
        this.model.user_uuid = get(this.user, 'uuid', '')
        this.$emit('submit', { ...this.model })
      }
    },
    watch: {
      'client.uuid'(newId) {
        this.model.client_id = newId
      }
    }
  }
</script>
<style>
</style>
